import React, { useEffect,useState } from 'react';
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { makeStyles, IconButton, Button, Box, Tooltip } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu'; 
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import BrightnessLowIcon from '@material-ui/icons/BrightnessLow';
import Brightness3Icon from '@material-ui/icons/Brightness3';
import MenuAndroid from '../AppAndroid';
const drawerWidth = 240;

const useStyles =makeStyles(theme=>({    
    menuButton: {
        marginRight: theme.spacing(2),
    /*     [theme.breakpoints.up('lg')]: {
            display: 'none',
          }, */
      },
    mititulo:{
        textAlign:'center',
    },
    appBar: {
        [theme.breakpoints.up('sm')]: {
          //  width: `calc(100% - ${drawerWidth}px)`,
           width: `calc(100%)`,
            marginLeft: drawerWidth,
          },
      },
      appBarSinloguear: {
        
            width: `100% `,
            //marginLeft: drawerWidth,          
      },
}))

const Navbar = (propiedades) => {
    const misclases=useStyles()
    let history = useHistory();
    const {guardarUsuario}=React.useContext(AuthContext);
    const {generales,guardarGenerales}=React.useContext(GeneralesContext);
    const [mostrarTema, setMostrarTema]=useState(false);    
    //let auxTitulo1='Pruebas - '+generales.Titulo
    //let auxTitulo2='Pruebas - ALL-IN-ONE'
    let auxTitulo1=generales.Titulo    
    let auxTitulo2='ALL-IN-ONE'

    useEffect(()=>{
        if (propiedades.usuario.length !==0) {
            const idusu = localStorage.getItem('UsuId');
            if (idusu && parseInt(idusu) ===1) {
                setMostrarTema(true)    
            }
            
        }

    },[propiedades.usuario])

    const cambiarTema=(auxColor)=>{
        propiedades.setColorTema(!auxColor)
        localStorage.setItem('ColorTheme',!auxColor);
        //console.log(!auxColor);       
    }

    
    const CerrarSesion = e=>{
        e.preventDefault();
        localStorage.clear();
        guardarGenerales([])       	
        guardarUsuario([])
        history.push("/")			
    }
    return (    
    <AppBar className={propiedades.usuario.length !==0 ? misclases.appBar
        :misclases.appBarSinloguear} position="fixed" color="primary">
        <Toolbar>
        {propiedades.usuario.length !== 0  ?
            <IconButton color="inherit"  size='small' aria-label="menu" className={misclases.menuButton} onClick={()=>propiedades.funcionAbrir()} >
                <MenuIcon/>
            </IconButton>
        :null}
        <Box flexGrow={1}>
            <Typography  variant="h6" className={misclases.mititulo}>
                {generales.length!==0 ? auxTitulo1 : auxTitulo2}
            </Typography>
        </Box>
         <Typography variant="h6" style={{marginRight:"1rem"}}>
            PRUEBAS
        </Typography> 
       {/* 
        <MenuAndroid/>*/}
        
        {propiedades.usuario.length!==0?
        <Box>
            {mostrarTema?
            <Tooltip title={!propiedades.colorTema?`Cambiar a Modo Oscuro`:`Cambiar a Modo Claro`}>
                <IconButton color="inherit" onClick={()=>cambiarTema(propiedades.colorTema)} 
                    className={misclases.menuButton} aria-label="menu"  size='small'
                >
                    {propiedades.colorTema ? <Brightness3Icon/>: <BrightnessLowIcon/> }
                </IconButton>
            </Tooltip>
            :null}
            <Button variant="text" color="inherit" onClick={CerrarSesion}>
                Cerrar Sesion
            </Button>
        </Box>
        :null}
        {/* */}
        </Toolbar>
    </AppBar>
        
    );
}
 
export default Navbar;